import { MBText } from '@shared/components/MBText';
import { MBView } from '@shared/components/MBView';
import { Colors } from '@shared/styles';
import { Styles } from './styles';

export interface MBModalTitleProps {
  title: string;

  /*
        Does the modal have a shadow? If yes, the background color is set
        to white and there is a slight drop shadow below it. This makes
        the title stick out compared to the rest of the content. Suitable
        eg if the content isn't white
    */
  shadow?: boolean;

  // Selected props from MBModalProps
  onClose?: () => void;
  onBack?: () => void;
  isCloseButtonHidden?: boolean;
}

export function MBModalTitle({ title, shadow }: MBModalTitleProps) {
  return (
    <MBView center padding={2.5} paddingHorizontal={5} style={shadow && Styles.titleWithShadow}>
      <MBText
        numberOfLines={1}
        center
        bold
        size="large"
        style={Styles.titleText}
        color={Colors.v2.purple}
      >
        {title}
      </MBText>
    </MBView>
  );
}
